import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=20b6a04b&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=20b6a04b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b6a04b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b6a04b')) {
      api.createRecord('20b6a04b', component.options)
    } else {
      api.reload('20b6a04b', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=20b6a04b&scoped=true&", function () {
      api.rerender('20b6a04b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27LnDkt6wb5zl/JS/comp/PopupDialog.vue"
export default component.exports